(()=>{
 document.querySelectorAll('script[data-mf-variant-titles]').forEach(node=>{
  const root=document.getElementById(node.dataset.productInfo);
  if(!root)return;
  let titles;try{titles=JSON.parse(node.textContent)}catch{return}
  const sync=()=>{
   const input=root.querySelector('product-form form [name="id"]');
   const title=input&&titles[String(input.value)];
   if(!title)return;
   root.querySelectorAll('.product__title h1,.product__title h2').forEach(e=>{if(e.textContent!==title)e.textContent=title});
  };
  let frame;const update=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(sync)};
  root.addEventListener('change',update);
  new MutationObserver(update).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['value']});
  sync();
 });
})();
